import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUbiquitiComponent } from './simple-icons-ubiquiti.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUbiquitiComponent ],
    exports:      [ SimpleIconsUbiquitiComponent ],
    bootstrap:    []
})
export class SimpleIconsUbiquitiModule {}
